import React, { memo } from "react";
import styled from "styled-components";
import { device } from "theme/Breakpoints";
import { partners } from "./mock";
import PartnersItem from "./PartnersItem";

interface PartnersGridProps {}

const PartnersGrid: React.FC<PartnersGridProps> = ({}) => {
  return (
    <PartnersGridContainer>
      {partners.map((i, idx) => {
        return <PartnersItem key={idx} item={i} />;
      })}
    </PartnersGridContainer>
  );
};

const PartnersGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: auto;
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  margin-bottom: 30px;

  @media only screen and (${device.tablet}) {
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    grid-template-columns: repeat(3, 1fr);
  }
  @media only screen and (${device.laptop}) {
    grid-template-columns: repeat(5, 1fr);
  }
`;

export default memo(PartnersGrid);
